import {ALGORITHM_PANEL_CHANGE, actionAlgorithmPanel, payloadAlgorithmPanel, RESET_ALGORITHM_PANEL} from '../../Actions/Atlas/algorithmPanel.action';
import { RESET_ALL } from '../../Actions/globals.actions';

const defaultAlgorithmPanelData: payloadAlgorithmPanel = {
    type: 'maxrect',
    width: 1024,
    height: 1024,
    size: 1,
    extrusion: 0,
    separation: 0
}

export default (state: payloadAlgorithmPanel = defaultAlgorithmPanelData, action: actionAlgorithmPanel ) => {
    switch (action.type) {
        case ALGORITHM_PANEL_CHANGE: {
            return action.payload;
        }
        case RESET_ALL: {
            return defaultAlgorithmPanelData;
        }
        case RESET_ALGORITHM_PANEL: {
            return defaultAlgorithmPanelData;
        }
        default: 
            return state;
    }
}
